document.querySelectorAll(".mainSlider").forEach((slider, index) => {
  new Swiper(slider, {
    effect: "slide",
    speed: 1000,
    autoplay: {
      delay: 3000, // Time between slides in ms (adjust as needed)
      disableOnInteraction: true, // Keeps autoplay running after touch/click
      pauseOnMouseEnter: true
    },
    loop:true,
    slidesPerView: 1,
    pagination: { 
        el:slider.querySelector(".swiper-pagination"),
        clickable: true
    },
  });
});

// document.addEventListener("DOMContentLoaded", () => {
//   const wrappers = document.querySelectorAll(".marqueeTicker");
//   wrappers.forEach((wrapper) => {
//     const content = wrapper.querySelector(".ticker-content");
//     if (!content) return;
//     const clone = content.cloneNode(true);
//     wrapper.appendChild(clone);
//     const contentWidth = content.offsetWidth;

//     // Create a separate GSAP animation instance for each ticker
//     const marqueeAnimation = gsap.to(wrapper, {
//       x: `-=${contentWidth}`,
//       duration: 30, // Speed
//       ease: "none",
//       repeat: -1
//     });
//     wrapper.addEventListener("mouseenter", () => marqueeAnimation.pause());
//     wrapper.addEventListener("mouseleave", () => marqueeAnimation.play());
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  const wrappers = document.querySelectorAll(".marqueeTicker");
  
  wrappers.forEach((wrapper) => {
    const content = wrapper.querySelector(".ticker-content");
    if (!content) return;
    
    const clone = content.cloneNode(true);
    wrapper.appendChild(clone);
    
    const contentWidth = content.offsetWidth;
    
    // Check if the page or wrapper is in RTL (Arabic) mode
    const isRtl = window.getComputedStyle(wrapper).direction === "rtl" || 
                  document.documentElement.dir === "rtl";
    
    // In RTL, we want it to scroll the opposite direction (+ instead of -)
    const scrollDistance = isRtl ? contentWidth : `-=${contentWidth}`;

    const marqueeAnimation = gsap.to(wrapper, {
      x: scrollDistance,
      duration: 30,
      ease: "none",
      repeat: -1
    });

    wrapper.addEventListener("mouseenter", () => marqueeAnimation.pause());
    wrapper.addEventListener("mouseleave", () => marqueeAnimation.play());
  });
});

document.addEventListener("DOMContentLoaded",()=>{
  document.querySelectorAll(".prodCardSlider").forEach((slider,index)=>{
    const prevArrow = slider.parentElement.querySelector(".prev");
    const nextArrow = slider.parentElement.querySelector(".next");
    new Swiper(slider,{
      effect:"slide",speed:1000,
      navigation:{
        nextEl:nextArrow,
        prevEl:prevArrow
      },
      breakpoints:{
        150:{
          slidesPerView:1.6,
          spaceBetween:0
        },
        576:{
          slidesPerView:3,
          spaceBetween:0
        },
        769:{
          slidesPerView:3.5,
          spaceBetween:0
        },
        1025:{
          slidesPerView:4,
          spaceBetween:0
        }
      }
    });
  });
});

document.addEventListener("DOMContentLoaded",()=>{
  document.querySelectorAll(".categoySlider").forEach((slider,index)=>{
    const prevArrow = slider.parentElement.querySelector(".prev");
    const nextArrow = slider.parentElement.querySelector(".next");
    new Swiper(slider,{
      effect:"slide",
      speed:1000,
      navigation:{
        nextEl:nextArrow,
        prevEl:prevArrow
      },
      breakpoints:{
        150:{
          slidesPerView:1.6,
          spaceBetween:0
        },
        576:{
          slidesPerView:3,
          spaceBetween:0
        },
        769:{
          slidesPerView:3.5,
          spaceBetween:0
        },
        1025:{
          slidesPerView:4,
          spaceBetween:0
        }
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  function FAQsAccordion() {
    var accordionSections = document.querySelectorAll(".faqs-accordion-item");

    accordionSections.forEach(function (section) {
      var header = section.querySelector(".faqs-accordion-item-header");
      var body = section.querySelector(".faqs-accordion-item-body");

      header.addEventListener("click", function () {
        var isActive = header.classList.contains("active");

        // Close all open accordion items
        document.querySelectorAll(".faqs-accordion-item-header.active").forEach(function (activeHeader) {
          activeHeader.classList.remove("active");

          var activeBody = activeHeader
            .closest(".faqs-accordion-item")
            .querySelector(".faqs-accordion-item-body");

          activeBody.style.maxHeight = "0px";
        });

        // Open the clicked item only if it was previously closed
        if (!isActive) {
          header.classList.add("active");
          body.style.maxHeight = body.scrollHeight + "px";
        }
      });
    });
  }

  FAQsAccordion();
});

// })

// GSAP ANIMATION 
document.addEventListener("DOMContentLoaded", () => {
  // Ensure GSAP and ScrollTrigger are loaded
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    console.warn("GSAP or ScrollTrigger plugin is missing.");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  const initPerfumeAnimations = (container = document) => {
    const sections = container.querySelectorAll("[data-gsap-section]");

    sections.forEach((section) => {
      // 1. Left Cluster (Slide in from Left)
      const leftCluster = section.querySelector('[data-gsap="fade-right"]');
      if (leftCluster) {
        gsap.fromTo(
          leftCluster,
          { opacity: 0, x: -60 },
          {
            opacity: 1,
            x: 0,
            duration: 1.2,
            ease: "power3.out",
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none"
            }
          }
        );
      }

      // 2. Right Cluster (Slide in from Right)
      const rightCluster = section.querySelector('[data-gsap="fade-left"]');
      if (rightCluster) {
        gsap.fromTo(
          rightCluster,
          { opacity: 0, x: 60 },
          {
            opacity: 1,
            x: 0,
            duration: 1.2,
            ease: "power3.out",
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              toggleActions: "play none none none"
            }
          }
        );
      }

      // 3. Center Text Stagger (Fade Up Sequence)
      const fadeUpElements = section.querySelectorAll('[data-gsap="fade-up"]');
      if (fadeUpElements.length > 0) {
        gsap.fromTo(
          fadeUpElements,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 1.0,
            stagger: 0.15,
            ease: "power2.out",
            scrollTrigger: {
              trigger: section,
              start: "top 75%",
              toggleActions: "play none none none"
            }
          }
        );
      }
    });
  };

  // Initial Run
  initPerfumeAnimations();

  // Re-initialize inside Shopify Theme Editor when customizer refreshes section
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      initPerfumeAnimations(event.target);
      ScrollTrigger.refresh();
    });
  }
});